/* eslint-disable id-match */
import PropTypes from 'prop-types';
import { Range } from 'rc-slider';
import React, { useState, useEffect, useContext } from 'react';
import {
  APPLY,
  CLEAR,
} from '../../../brands/default/content/components/_generic';
import ThemeContext from '../../../providers/ThemeProvider';
import RangeActionButton from './RangeActionButton';

const RangeSelector = ({
  label,
  value,
  min,
  max,
  marks,
  onChange,
  onReset,
  invert,
  inline,
}) => {
  const theme = useContext(ThemeContext);

  // Keep a local value stored -- on mobile we have an apply button which
  // only commits the value after it's been clicked
  const [localValue, setLocalValue] = useState(value);
  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  // the design asks for only the selected values to have a visible label
  const labels = Object.entries(marks).reduce((out, [key, mark], index) => {
    out[key] = {
      ...mark,
      style: {
        display: localValue.includes(index) ? undefined : 'none',
        transform:
          index === localValue[0]
            ? 'translateX(calc(-100% + 5px))'
            : 'translateX(-4px)',
      },
    };

    return out;
  }, {});

  return (
    <>
      {!inline && (
        <>
          <RangeActionButton onClick={onReset}>
            {CLEAR.toUpperCase()}
          </RangeActionButton>
          <div className="range-title">{label}</div>
        </>
      )}
      <div className="range-container">
        <Range
          allowCross={false}
          dotStyle={{ display: 'none' }}
          marks={labels}
          max={max}
          min={min}
          onAfterChange={(value_) => {
            if (inline) {
              onChange(value_);
            }
          }}
          onChange={setLocalValue}
          reverse={false}
          value={localValue}
        />
      </div>
      {!inline && (
        <RangeActionButton
          className="no-margin center"
          onClick={() => onChange(localValue)}
        >
          {APPLY.toUpperCase()}
        </RangeActionButton>
      )}
      <style jsx>{`
        .range-title {
          font-size: 16px;
          font-weight: bold;
          position: relative;
          padding-left: 20px;
        }
        .range-container {
          margin: ${inline ? '0' : '40px 30px 40px 30px'};
        }
      `}</style>
      <style global jsx>{`
        .rc-slider-handle {
          height: 25px;
          width: 25px;
          margin-top: -10px;
        }
        .rc-slider-handle,
        .rc-slider-handle:hover,
        .rc-slider-handle-focused,
        .rc-slider-handle-dragging {
          border-color: ${theme.colors.primary} !important;
        }
        .rc-slider-handle-dragging {
          box-shadow: 0 0 0 5px ${theme.colors.primarypale} !important;
        }
        .rc-slider-rail {
          background-color: ${invert ? theme.colors.primarypale : '#e9e9e9'};
        }
        .rc-slider-track {
          background-color: ${invert ? '#fff' : theme.colors.primary};
        }
        .rc-slider-mark-text {
          font-size: 14px;
          font-weight: 700;
          top: ${inline ? 5 : -48}px;
          color: ${invert ? '#fff' : 'inherit'};
        }
      `}</style>
    </>
  );
};

RangeSelector.propTypes = {
  inline: PropTypes.bool,
  invert: PropTypes.bool,
  label: PropTypes.string,
  marks: PropTypes.shape({
    label: PropTypes.string,
    style: PropTypes.object,
  }),
  max: PropTypes.number,
  min: PropTypes.number,
  onChange: PropTypes.func,
  onReset: PropTypes.func,
  value: PropTypes.arrayOf(PropTypes.number),
};

export default RangeSelector;
